<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Idioma: login, registro y paginas publicas (la gente llega sin sesion) -->
<div class="fixed right-3 top-3 z-50 print:hidden">
    <language-toggle></language-toggle>
</div>

<!-- Wrapper -->
<div class="flex w-full flex-auto flex-col">
    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
</div>
